<template>
    <v-select
        :options="question.settings.options"
        dir="rtl"
        @input="$emit('input', $event)"
    >
        <template #open-indicator>
            <b class="button" />
        </template>

        <template #no-options>
            יש לבחור מתוך הרשימה
        </template>
    </v-select>
</template>

<script>
import vSelect from 'vue-select';

export default {
    components: {
        vSelect
    },

    props: {
        question: {
            type: Object,
            required: true
        }
    }
};
</script>
